import React, { useRef, useState } from "react";
import "./CommonComp.scss";
import { IoCheckmarkSharp } from "react-icons/io5";
import { FaPhone } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import emailjs from "@emailjs/browser";
import ReCAPTCHA from "react-google-recaptcha";
const ContactForm = () => {
  const form = useRef();
  const recaptchaRef = useRef();

  const [statusMessage, setStatusMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);

  const sendEmail = (e) => {
    e.preventDefault();

    // 🚨 Check captcha first
    if (!captchaValue) {
      setStatusMessage("Please verify that you are not a robot.");
      setIsError(true);
      return;
    }

    setIsSending(true);
    setStatusMessage("Sending...");
    setIsError(false);

    emailjs
      .sendForm(
        "service_vgyuibf",
        "template_2kyj625",
        form.current,
        "3-fe2hI7FyGmze-cd",
      )
      .then(
        () => {
          setStatusMessage("Message sent successfully!");
          setIsError(false);
          e.target.reset();
          setCaptchaValue(null);
          recaptchaRef.current.reset();
          setIsSending(false);

          setTimeout(() => setStatusMessage(""), 4000);
        },
        () => {
          setStatusMessage("Failed to send message. Please try again.");
          setIsError(true);
          setIsSending(false);

          setTimeout(() => setStatusMessage(""), 4000);
        },
      );
  };

  return (
    <>
      <section id="getintouch" className="mobile-spacing tablet-spacing">
        <div className="container-fluid">
          <div className="row">
            {/* left text */}
            <div className="col-md-6 getintouch-left-text">
              <span className="Professionals-text">
                <span className="text">
                  <h3 className="sub-head">/ Connect Now</h3>
                  <h2 className="main-head">Get a Free Quote</h2>
                </span>
              </span>

              <div className="get-in-touch-inner">
                <ul className="check-list">
                  <li>
                    <IoCheckmarkSharp /> <span>Personalized Services</span>
                  </li>
                  <li>
                    <IoCheckmarkSharp /> <span>Certified Team</span>
                  </li>
                  <li>
                    <IoCheckmarkSharp /> <span>Proven Track Record</span>
                  </li>
                  <li>
                    <IoCheckmarkSharp /> <span>Local Expertise</span>
                  </li>
                  <li>
                    <IoCheckmarkSharp /> <span>Community Focused</span>
                  </li>
                </ul>

                <p className="experts">Want to talk to an expert?</p>
                <span className="number">
                  <a href="tel:(630) 922-8600">
                    <span>
                      <FaPhone />
                    </span>{" "}
                    (630) 922-8600
                  </a>
                </span>

                <p className="socialize">Let's Socialize</p>
                <ul className="socialize-icon">
                  <a
                    href="https://www.facebook.com/ChawlaCPA/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <li>
                      <FaFacebookF />
                    </li>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/chawla-associates-inc/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <li>
                      <FaLinkedinIn />
                    </li>
                  </a>
                </ul>
              </div>
            </div>

            {/* form */}
            <div className="col-md-6 getintouch-form p-xs-0">
              <div className="contact-form">
                <form ref={form} onSubmit={sendEmail}>
                  <span>
                    <label>Full Name*</label>
                    <input
                      type="text"
                      name="first_name"
                      required
                      disabled={isSending}
                    />
                  </span>

                  <span>
                    <label>Phone Number*</label>
                    <input
                      type="tel"
                      name="phone_number"
                      required
                      disabled={isSending}
                    />
                  </span>

                  <span>
                    <label>Email Address*</label>
                    <input
                      type="email"
                      name="email_address"
                      required
                      disabled={isSending}
                    />
                  </span>

                  <span>
                    <label>Message*</label>
                    <textarea
                      name="message"
                      required
                      disabled={isSending}
                    ></textarea>
                  </span>

                  {/* ✅ Google reCAPTCHA */}
                  <div style={{ marginBottom: "15px" }}>
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey="6Let13AsAAAAAENZwBHFIHaOyQesGHGn3MixbKGJ"
                      onChange={(value) => setCaptchaValue(value)}
                    />
                  </div>

                  <button
                    type="submit"
                    className="common-btn"
                    disabled={isSending}
                  >
                    {isSending ? "Sending..." : "Submit"}
                  </button>
                </form>

                {/* ✅ Status Message */}
                {statusMessage && (
                  <p
                    className={`form-message ${
                      isError ? "error-message" : "success-message"
                    }`}
                  >
                    {statusMessage}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactForm;
